/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月02日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
const PROVINCE = [
	['340000', ['安徽', '安徽', 'Anhui'], '1'],
	['110000', ['北京', '北京', 'Beijing'], '1'],
	['500000', ['重庆', '重慶', 'Chongqing'], '1'],
	['350000', ['福建', '福建', 'Fujian'], '1'],
	['620000', ['甘肃', '甘肅', 'Gansu'], '1'],
	['440000', ['广东', '廣東', 'Guangdong'], '1'],
	['450000', ['广西', '廣西', 'Guangxi'], '1'],
	['520000', ['贵州', '貴州', 'Guizhou'], '1'],
	['460000', ['海南', '海南', 'Hainan'], '1'],
	['130000', ['河北', '河北', 'Hebei'], '1'],
	['230000', ['黑龙江', '黑龍江', 'Heilongjiang'], '1'],
	['410000', ['河南', '河南', 'Henan'], '1'],
	['420000', ['湖北', '湖北', 'Hubei'], '1'],
	['430000', ['湖南', '湖南', 'Hunan'], '1'],
	['320000', ['江苏', '江蘇', 'Jiangsu'], '1'],
	['360000', ['江西', '江西', 'Jiangxi'], '1'],
	['220000', ['吉林', '吉林', 'Jilin'], '1'],
	['210000', ['辽宁', '遼寧', 'Liaoning'], '1'],
	['150000', ['内蒙古', '內蒙古', 'Inner Mongolia'], '1'],
	['640000', ['宁夏', '寧夏', 'Ningxia'], '1'],
	['630000', ['青海', '青海', 'Qinghai'], '1'],
	['370000', ['山东', '山東', 'Shandong'], '1'],
	['310000', ['上海', '上海', 'Shanghai'], '1'],
	['140000', ['山西', '山西', 'Shanxi'], '1'],
	['610000', ['陕西', '陝西', 'Shaanxi'], '1'],
	['510000', ['四川', '四川', 'Sichuan'], '1'],
	['120000', ['天津', '天津', 'Tianjin'], '1'],
	['650000', ['新疆', '新疆', 'Xinjiang'], '1'],
	['540000', ['西藏', '西藏', 'Tibet'], '1'],
	['530000', ['云南', '雲南', 'Yunnan'], '1'],
	['330000', ['浙江', '浙江', 'Zhejiang'], '1']
];

const CITY = [
	['110100', ['北京', '北京', 'Beijing'], '110000'],
	['120100', ['天津', '天津', 'Tianjin'], '120000'],
	['130100', ['石家庄', '石家莊', 'Shijiazhuang'], '130000'],
	['130200', ['唐山', '唐山', 'Tangshan'], '130000'],
	['130300', ['秦皇岛', '秦皇島', 'Qinhuangdao'], '130000'],
	['130400', ['邯郸', '邯鄲', 'Handan'], '130000'],
	['130500', ['邢台', '邢臺', 'Xingtai'], '130000'],
	['130600', ['保定', '保定', 'Baoding'], '130000'],
	['130700', ['张家口', '張家口', 'Zhangjiakou'], '130000'],
	['130800', ['承德', '承德', 'Chengde'], '130000'],
	['130900', ['沧州', '滄州', 'Zhangzhou'], '130000'],
	['131000', ['廊坊', '廊坊', 'Langfang'], '130000'],
	['131100', ['衡水', '衡水', 'Hengshui'], '130000'],
	['140100', ['太原', '太原', 'Taiyuan'], '140000'],
	['140200', ['大同', '大同', 'Datong'], '140000'],
	['140300', ['阳泉', '陽泉', 'Yangquan'], '140000'],
	['140400', ['长治', '長治', 'Changzhi'], '140000'],
	['140500', ['晋城', '晉城', 'Jincheng'], '140000'],
	['140600', ['朔州', '朔州', 'Zhangzhou'], '140000'],
	['140700', ['晋中', '晉中', 'Jinzhong'], '140000'],
	['140800', ['运城', '運城', 'Yuncheng'], '140000'],
	['140900', ['忻州', '忻州', 'Zhangzhou'], '140000'],
	['141000', ['临汾', '臨汾', 'Linyi'], '140000'],
	['141100', ['吕梁', '呂梁', 'Lu Liang'], '140000'],
	['150100', ['呼和浩特', '呼和浩特', 'Hohhot'], '150000'],
	['150200', ['包头', '包頭', 'Baotou'], '150000'],
	['150300', ['乌海', '烏海', 'Wuhai'], '150000'],
	['150400', ['赤峰', '赤峰', 'Chifeng'], '150000'],
	['150500', ['通辽', '通遼', 'Tongliao'], '150000'],
	['150600', ['鄂尔多斯', '鄂爾多斯', 'Ordos'], '150000'],
	['150700', ['呼伦贝尔', '呼倫貝爾', 'Hulunbeier'], '150000'],
	['150800', ['巴彦淖尔', '巴彥淖爾', 'Bayannaoer'], '150000'],
	['150900', ['乌兰察布', '烏蘭察布', 'Ulanchabu'], '150000'],
	['152200', ['兴安', '興安', "Xing'an"], '150000'],
	['152500', ['锡林郭勒', '錫林郭勒', 'Xilin Gol'], '150000'],
	['152900', ['阿拉善', '阿拉善', 'Alashan'], '150000'],
	['210100', ['沈阳', '沈陽', 'Shenyang'], '210000'],
	['210200', ['大连', '大連', 'Dalian'], '210000'],
	['210300', ['鞍山', '鞍山', 'Anshan'], '210000'],
	['210400', ['抚顺', '撫順', 'Fushun'], '210000'],
	['210500', ['本溪', '本溪', 'Benxi'], '210000'],
	['210600', ['丹东', '丹東', 'Dandong'], '210000'],
	['210700', ['锦州', '錦州', 'Jinzhou'], '210000'],
	['210800', ['营口', '營口', 'Yingkou'], '210000'],
	['210900', ['阜新', '阜新', 'Fuxin'], '210000'],
	['211000', ['辽阳', '遼陽', 'Liaoyang'], '210000'],
	['211100', ['盘锦', '盤錦', 'Panjin'], '210000'],
	['211200', ['铁岭', '鐵嶺', 'Tieling'], '210000'],
	['211300', ['朝阳', '朝陽', 'Chaoyang'], '210000'],
	['211400', ['葫芦岛', '葫蘆島', 'Huludao'], '210000'],
	['220100', ['长春', '長春', 'Changchun'], '220000'],
	['220200', ['吉林', '吉林', 'Jilin'], '220000'],
	['220300', ['四平', '四平', 'Siping'], '220000'],
	['220400', ['辽源', '遼源', 'Liaoyuan'], '220000'],
	['220500', ['通化', '通化', 'Tonghua'], '220000'],
	['220600', ['白山', '白山', 'Hakusan'], '220000'],
	['220700', ['松原', '松原', 'Matsubara'], '220000'],
	['220800', ['白城', '白城', 'Baicheng'], '220000'],
	['222400', ['延边朝鲜族', '延邊朝鮮族', 'Yanbian Korean'], '220000'],
	['230100', ['哈尔滨', '哈爾濱', 'Harbin'], '230000'],
	['230200', ['齐齐哈尔', '齊齊哈爾', 'Qiqihar'], '230000'],
	['230300', ['鸡西', '雞西', 'Jixi'], '230000'],
	['230400', ['鹤岗', '鶴崗', 'Hegang'], '230000'],
	['230500', ['双鸭山', '雙鴨山', 'Shuangyashan'], '230000'],
	['230600', ['大庆', '大慶', 'Daqing'], '230000'],
	['230700', ['伊春', '伊春', 'Yichun'], '230000'],
	['230800', ['佳木斯', '佳木斯', 'Jiamusi'], '230000'],
	['230900', ['七台河', '七臺河', 'Qitaihe'], '230000'],
	['231000', ['牡丹江', '牡丹江', 'Mudanjiang'], '230000'],
	['231100', ['黑河', '黑河', 'Heihe'], '230000'],
	['231200', ['绥化', '綏化', 'Suihua'], '230000'],
	['232700', ['大兴安岭', '大興安嶺', 'Daxinganling'], '230000'],
	['310100', ['上海', '上海', 'Shanghai'], '310000'],
	['320100', ['南京', '南京', 'Nanjing'], '320000'],
	['320200', ['无锡', '無錫', 'Wuxi'], '320000'],
	['320300', ['徐州', '徐州', 'Xuzhou'], '320000'],
	['320400', ['常州', '常州', 'Changzhou'], '320000'],
	['320500', ['苏州', '蘇州', 'Suzhou'], '320000'],
	['320600', ['南通', '南通', 'Nantong'], '320000'],
	['320700', ['连云港', '連雲港', 'Lianyungang'], '320000'],
	['320800', ['淮安', '淮安', "Huai'an"], '320000'],
	['320900', ['盐城', '鹽城', 'Yancheng'], '320000'],
	['321000', ['扬州', '揚州', 'Yangzhou'], '320000'],
	['321100', ['镇江', '鎮江', 'Zhenjiang'], '320000'],
	['321200', ['泰州', '泰州', 'Taizhou'], '320000'],
	['321300', ['宿迁', '宿遷', 'Suqian'], '320000'],
	['330100', ['杭州', '杭州', 'Hangzhou'], '330000'],
	['330200', ['宁波', '寧波', 'Ningbo'], '330000'],
	['330300', ['温州', '溫州', 'Wenzhou'], '330000'],
	['330400', ['嘉兴', '嘉興', 'Jiaxing'], '330000'],
	['330500', ['湖州', '湖州', 'Huzhou'], '330000'],
	['330600', ['绍兴', '紹興', 'Shaoxing'], '330000'],
	['330700', ['金华', '金華', 'Jinhua'], '330000'],
	['330800', ['衢州', '衢州', 'Zhangzhou'], '330000'],
	['330900', ['舟山', '舟山', 'Zhoushan'], '330000'],
	['331000', ['台州', '臺州', 'Taizhou'], '330000'],
	['331100', ['丽水', '麗水', 'Lishui'], '330000'],
	['340100', ['合肥', '合肥', 'Hefei'], '340000'],
	['340200', ['芜湖', '蕪湖', 'Wuhu'], '340000'],
	['340300', ['蚌埠', '蚌埠', '蚌埠'], '340000'],
	['340400', ['淮南', '淮南', 'Huainan'], '340000'],
	['340500', ['马鞍山', '馬鞍山', 'Ma On Shan'], '340000'],
	['340600', ['淮北', '淮北', 'Huaibei'], '340000'],
	['340700', ['铜陵', '銅陵', 'Tongling'], '340000'],
	['340800', ['安庆', '安慶', 'Anqing'], '340000'],
	['341000', ['黄山', '黃山', 'Huangshan'], '340000'],
	['341100', ['滁州', '滁州', 'Zhangzhou'], '340000'],
	['341200', ['阜阳', '阜陽', 'Fuyang'], '340000'],
	['341300', ['宿州', '宿州', 'Suzhou'], '340000'],
	['341500', ['六安', '六安', "Lu'an"], '340000'],
	['341600', ['亳州', '亳州', 'Zhangzhou'], '340000'],
	['341700', ['池州', '池州', 'Chizhou'], '340000'],
	['341800', ['宣城', '宣城', 'Xuancheng'], '340000'],
	['350100', ['福州', '福州', 'Fuzhou'], '350000'],
	['350200', ['厦门', '廈門', 'Xiamen'], '350000'],
	['350300', ['莆田', '莆田', 'Putian'], '350000'],
	['350400', ['三明', '三明', 'Sanming'], '350000'],
	['350500', ['泉州', '泉州', 'Quanzhou'], '350000'],
	['350600', ['漳州', '漳州', 'Zhangzhou'], '350000'],
	['350700', ['南平', '南平', 'Nanping'], '350000'],
	['350800', ['龙岩', '龍巖', 'Longyan'], '350000'],
	['350900', ['宁德', '寧德', 'Ningde'], '350000'],
	['360100', ['南昌', '南昌', 'Nanchang'], '360000'],
	['360200', ['景德镇', '景德鎮', 'Jingdezhen'], '360000'],
	['360300', ['萍乡', '萍鄉', 'Pingxiang'], '360000'],
	['360400', ['九江', '九江', 'Jiujiang'], '360000'],
	['360500', ['新余', '新余', 'Xinyu'], '360000'],
	['360600', ['鹰潭', '鷹潭', 'Yingtan'], '360000'],
	['360700', ['赣州', '贛州', 'Ganzhou'], '360000'],
	['360800', ['吉安', '吉安', "Ji'an"], '360000'],
	['360900', ['宜春', '宜春', 'Yichun'], '360000'],
	['361000', ['抚州', '撫州', 'Fuzhou'], '360000'],
	['361100', ['上饶', '上饒', 'Shangrao'], '360000'],
	['370100', ['济南', '濟南', 'Jinan'], '370000'],
	['370200', ['青岛', '青島', 'Qingdao'], '370000'],
	['370300', ['淄博', '淄博', 'Zibo'], '370000'],
	['370400', ['枣庄', '棗莊', 'Zaozhuang'], '370000'],
	['370500', ['东营', '東營', 'Dongying'], '370000'],
	['370600', ['烟台', '煙臺', 'Yantai'], '370000'],
	['370700', ['潍坊', '濰坊', 'Weifang'], '370000'],
	['370800', ['济宁', '濟寧', 'Jining'], '370000'],
	['370900', ['泰安', '泰安', 'Taian'], '370000'],
	['371000', ['威海', '威海', 'Weihai'], '370000'],
	['371100', ['日照', '日照', 'sunshine'], '370000'],
	['371200', ['莱芜', '萊蕪', 'Laiwu'], '370000'],
	['371300', ['临沂', '臨沂', 'Linyi'], '370000'],
	['371400', ['德州', '德州', 'Texas'], '370000'],
	['371500', ['聊城', '聊城', 'Liaocheng'], '370000'],
	['371600', ['滨州', '濱州', 'Binzhou'], '370000'],
	['371700', ['菏泽', '菏澤', 'Heze'], '370000'],
	['410100', ['郑州', '鄭州', 'Zhengzhou'], '410000'],
	['410200', ['开封', '開封', 'Opened'], '410000'],
	['410300', ['洛阳', '洛陽', 'Luoyang'], '410000'],
	['410400', ['平顶山', '平頂山', 'Pingdingshan'], '410000'],
	['410500', ['安阳', '安陽', 'Anyang'], '410000'],
	['410600', ['鹤壁', '鶴壁', 'Hebi'], '410000'],
	['410700', ['新乡', '新鄉', 'Xinxiang'], '410000'],
	['410800', ['焦作', '焦作', 'Jiaozuo'], '410000'],
	['410881', ['济源', '濟源', 'Jiyuan'], '410000'],
	['410900', ['濮阳', '濮陽', 'Fuyang'], '410000'],
	['411000', ['许昌', '許昌', 'Xu Chang'], '410000'],
	['411100', ['漯河', '漯河', 'Luohe'], '410000'],
	['411200', ['三门峡', '三門峽', 'Sanmenxia'], '410000'],
	['411300', ['南阳', '南陽', 'Nanyang'], '410000'],
	['411400', ['商丘', '商丘', 'Shangqiu'], '410000'],
	['411500', ['信阳', '信陽', 'Xinyang'], '410000'],
	['411600', ['周口', '周口', 'Zhoukou'], '410000'],
	['411700', ['驻马店', '駐馬店', 'Zhumadian store'], '410000'],
	['420100', ['武汉', '武漢', 'Wuhan'], '420000'],
	['420200', ['黄石', '黃石', 'Yellowstone'], '420000'],
	['420300', ['十堰', '十堰', 'Shiyan'], '420000'],
	['420500', ['宜昌', '宜昌', 'Yichang'], '420000'],
	['420600', ['襄阳', '襄陽', 'Fuyang'], '420000'],
	['420700', ['鄂州', '鄂州', 'Ezhou'], '420000'],
	['420800', ['荆门', '荊門', 'Jingmen'], '420000'],
	['420900', ['孝感', '孝感', 'Xiaogan'], '420000'],
	['421000', ['荆州', '荊州', 'Jingzhou'], '420000'],
	['421100', ['黄冈', '黃岡', 'Huanggang'], '420000'],
	['421200', ['咸宁', '鹹寧', 'Xianning'], '420000'],
	['421300', ['随州', '隨州', 'Suizhou'], '420000'],
	['422800', ['恩施', '恩施', 'Enshi'], '420000'],
	['429004', ['仙桃', '仙桃', 'Xiantao'], '420000'],
	['429005', ['潜江', '潛江', 'Qianjiang'], '420000'],
	['429006', ['天门', '天門', 'Tianmen'], '420000'],
	['429021', ['神农架', '神農架', 'Shennongjia'], '420000'],
	['430100', ['长沙', '長沙', 'Changsha'], '430000'],
	['430200', ['株洲', '株洲', 'Zhuzhou'], '430000'],
	['430300', ['湘潭', '湘潭', 'Xiangtan'], '430000'],
	['430400', ['衡阳', '衡陽', 'Hengyang'], '430000'],
	['430500', ['邵阳', '邵陽', 'Shaoyang'], '430000'],
	['430600', ['岳阳', '嶽陽', 'Yue Yang'], '430000'],
	['430700', ['常德', '常德', 'Changde'], '430000'],
	['430800', ['张家界', '張家界', 'Zhangjiajie'], '430000'],
	['430900', ['益阳', '益陽', 'Yiyang'], '430000'],
	['431000', ['郴州', '郴州', 'Zhangzhou'], '430000'],
	['431100', ['永州', '永州', 'Yongzhou'], '430000'],
	['431200', ['怀化', '懷化', 'Huaihua'], '430000'],
	['431300', ['娄底', '婁底', 'Bottom'], '430000'],
	['433100', ['湘西', '湘西', 'Xiangxi'], '430000'],
	['440100', ['广州', '廣州', 'Guangzhou'], '440000'],
	['440200', ['韶关', '韶關', 'Shaoguan'], '440000'],
	['440300', ['深圳', '深圳', 'Shenzhen'], '440000'],
	['440400', ['珠海', '珠海', 'Zhuhai'], '440000'],
	['440500', ['汕头', '汕頭', 'Shantou'], '440000'],
	['440600', ['佛山', '佛山', 'Foshan'], '440000'],
	['440700', ['江门', '江門', 'Jiangmen'], '440000'],
	['440800', ['湛江', '湛江', 'Zhanjiang'], '440000'],
	['440900', ['茂名', '茂名', 'Maoming'], '440000'],
	['441200', ['肇庆', '肇慶', 'Zhaoqing'], '440000'],
	['441300', ['惠州', '惠州', 'Huizhou'], '440000'],
	['441400', ['梅州', '梅州', 'Meizhou'], '440000'],
	['441500', ['汕尾', '汕尾', 'Iris'], '440000'],
	['441600', ['河源', '河源', 'Heyuan'], '440000'],
	['441700', ['阳江', '陽江', 'Yangjiang'], '440000'],
	['441800', ['清远', '清遠', 'Qingyuan'], '440000'],
	['441900', ['东莞', '東莞', 'Dongguan'], '440000'],
	['442000', ['中山', '中山', 'Zhongshan'], '440000'],
	['445100', ['潮州', '潮州', 'Chaozhou'], '440000'],
	['445200', ['揭阳', '揭陽', 'Jieyang'], '440000'],
	['445300', ['云浮', '雲浮', 'Yunfu'], '440000'],
	['450100', ['南宁', '南寧', 'Nanning'], '450000'],
	['450200', ['柳州', '柳州', 'Liuzhou'], '450000'],
	['450300', ['桂林', '桂林', 'Guilin'], '450000'],
	['450400', ['梧州', '梧州', 'Zhangzhou'], '450000'],
	['450500', ['北海', '北海', 'North Sea'], '450000'],
	['450600', ['防城港', '防城港', 'Fangchenggang'], '450000'],
	['450700', ['钦州', '欽州', 'Qinzhou'], '450000'],
	['450800', ['贵港', '貴港', 'Guigang'], '450000'],
	['450900', ['玉林', '玉林', 'Yulin'], '450000'],
	['451000', ['百色', '百色', 'Baise'], '450000'],
	['451100', ['贺州', '賀州', 'Hezhou'], '450000'],
	['451200', ['河池', '河池', 'Hechi'], '450000'],
	['451300', ['来宾', '來賓', 'guest'], '450000'],
	['451400', ['崇左', '崇左', 'Chongzuo'], '450000'],
	['460100', ['海口', '海口', 'Haikou'], '460000'],
	['460200', ['三亚', '三亞', 'Sanya'], '460000'],
	['460300', ['三沙', '三沙', 'Sansha'], '460000'],
	['469001', ['五指山', '五指山', 'Wuzhishan'], '460000'],
	['469002', ['琼海', '瓊海', 'Qiong Hai'], '460000'],
	['469003', ['儋州', '儋州', 'Zhangzhou'], '460000'],
	['469005', ['文昌', '文昌', 'Wenchang'], '460000'],
	['469006', ['万宁', '萬寧', 'Wanning'], '460000'],
	['469007', ['东方', '東方', 'East'], '460000'],
	['469025', ['定安', '定安', "Ding'an"], '460000'],
	['469026', ['屯昌', '屯昌', 'Suichang'], '460000'],
	['469027', ['澄迈', '澄邁', 'Chengmai'], '460000'],
	['469028', ['临高', '臨高', 'Lingao'], '460000'],
	['469030', ['白沙', '白沙', 'White sand'], '460000'],
	['469031', ['昌江', '昌江', 'Changjiang'], '460000'],
	['469033', ['乐东', '樂東', 'Ledong'], '460000'],
	['469034', ['陵水', '陵水', 'Lingshui'], '460000'],
	['469035', ['保亭', '保亭', 'Baoting'], '460000'],
	['469036', ['琼中', '瓊中', 'Qiongzhong'], '460000'],
	['500100', ['重庆', '重慶', 'Chongqing'], '500000'],
	['510100', ['成都', '成都', 'Chengdu'], '510000'],
	['510300', ['自贡', '自貢', 'Zigong'], '510000'],
	['510400', ['攀枝花', '攀枝花', 'Panzhihua'], '510000'],
	['510500', ['泸州', '瀘州', 'Luzhou'], '510000'],
	['510600', ['德阳', '德陽', 'Deyang'], '510000'],
	['510700', ['绵阳', '綿陽', 'Mianyang'], '510000'],
	['510800', ['广元', '廣元', 'Guangyuan'], '510000'],
	['510900', ['遂宁', '遂寧', 'Suining'], '510000'],
	['511000', ['内江', '內江', 'Neijiang'], '510000'],
	['511100', ['乐山', '樂山', 'Leshan'], '510000'],
	['511300', ['南充', '南充', 'Nanchong'], '510000'],
	['511400', ['眉山', '眉山', 'Meishan'], '510000'],
	['511500', ['宜宾', '宜賓', 'Yibin'], '510000'],
	['511600', ['广安', '廣安', "Guang'an"], '510000'],
	['511700', ['达州', '達州', 'Dazhou'], '510000'],
	['511800', ['雅安', '雅安', 'Yaan'], '510000'],
	['511900', ['巴中', '巴中', 'Bazhong'], '510000'],
	['512000', ['资阳', '資陽', 'Ziyang'], '510000'],
	['513200', ['阿坝', '阿壩', 'Aba'], '510000'],
	['513300', ['甘孜', '甘孜', 'Ganzi'], '510000'],
	['513400', ['凉山', '涼山', 'Liangshan'], '510000'],
	['520100', ['贵阳', '貴陽', 'Guiyang'], '520000'],
	['520200', ['六盘水', '六盤水', 'Liupanshui'], '520000'],
	['520300', ['遵义', '遵義', 'Zunyi'], '520000'],
	['520400', ['安顺', '安順', 'Anshun'], '520000'],
	['522200', ['铜仁', '銅仁', 'Tongren'], '520000'],
	['522300', ['黔西南', '黔西南', 'Southwestern Guizhou'], '520000'],
	['522400', ['毕节', '畢節', 'Bijie'], '520000'],
	['522600', ['黔东南', '黔東南', 'Southeastern Guizhou'], '520000'],
	['522700', ['黔南', '黔南', 'Weinan'], '520000'],
	['530100', ['昆明', '昆明', 'Kunming'], '530000'],
	['530300', ['曲靖', '曲靖', 'Qujing'], '530000'],
	['530400', ['玉溪', '玉溪', 'Yuxi'], '530000'],
	['530500', ['保山', '保山', 'Baoshan'], '530000'],
	['530600', ['昭通', '昭通', 'Zhaotong'], '530000'],
	['530700', ['丽江', '麗江', 'Lijiang'], '530000'],
	['530800', ['普洱', '普洱', "Pu'er"], '530000'],
	['530900', ['临沧', '臨滄', 'Linyi'], '530000'],
	['532300', ['楚雄', '楚雄', 'Chuxiong'], '530000'],
	['532500', ['红河', '紅河', 'Red river'], '530000'],
	['532600', ['文山', '文山', 'Wenshan'], '530000'],
	['532800', ['西双版纳', '西雙版納', 'Xishuangbanna'], '530000'],
	['532900', ['大理', '大理', 'Dali'], '530000'],
	['533100', ['德宏', '德宏', 'Dehong'], '530000'],
	['533300', ['怒江', '怒江', 'Nujiang'], '530000'],
	['533400', ['迪庆', '迪慶', 'Diqing'], '530000'],
	['540100', ['拉萨', '拉薩', 'Lhasa'], '540000'],
	['542100', ['昌都', '昌都', 'Changdu'], '540000'],
	['542200', ['山南', '山南', 'Shannan'], '540000'],
	['542300', ['日喀则', '日喀則', 'Shigatse'], '540000'],
	['542400', ['那曲', '那曲', 'Nagqu'], '540000'],
	['542500', ['阿里', '阿裏', 'Ali'], '540000'],
	['542600', ['林芝', '林芝', 'Lin Zhi'], '540000'],
	['610100', ['西安', '西安', "Xi'an"], '610000'],
	['610200', ['铜川', '銅川', 'Tongchuan'], '610000'],
	['610300', ['宝鸡', '寶雞', 'Baoji'], '610000'],
	['610400', ['咸阳', '鹹陽', 'Xianyang'], '610000'],
	['610500', ['渭南', '渭南', 'Weinan'], '610000'],
	['610600', ['延安', '延安', "Yan'an"], '610000'],
	['610700', ['汉中', '漢中', 'Hanzhong'], '610000'],
	['610800', ['榆林', '榆林', 'Yulin'], '610000'],
	['610900', ['安康', '安康', 'Ankang'], '610000'],
	['611000', ['商洛', '商洛', 'Shangluo'], '610000'],
	['620100', ['兰州', '蘭州', 'Lanzhou'], '620000'],
	['620200', ['嘉峪关', '嘉峪關', 'Jiayuguan'], '620000'],
	['620300', ['金昌', '金昌', 'Jinchang'], '620000'],
	['620400', ['白银', '白銀', 'silver'], '620000'],
	['620500', ['天水', '天水', 'Tianshui'], '620000'],
	['620600', ['武威', '武威', 'Wuwei'], '620000'],
	['620700', ['张掖', '張掖', 'Zhang Wei'], '620000'],
	['620800', ['平凉', '平涼', 'Pingliang'], '620000'],
	['620900', ['酒泉', '酒泉', 'Jiuquan'], '620000'],
	['621000', ['庆阳', '慶陽', 'Qingyang'], '620000'],
	['621100', ['定西', '定西', 'Dingxi'], '620000'],
	['621200', ['陇南', '隴南', 'Weinan'], '620000'],
	['622900', ['临夏', '臨夏', 'Linxia'], '620000'],
	['623000', ['甘南', '甘南', 'Gannan'], '620000'],
	['630100', ['西宁', '西寧', 'Xining'], '630000'],
	['632100', ['海东', '海東', 'Haidong'], '630000'],
	['632200', ['海北', '海北', 'Haibei'], '630000'],
	['632300', ['黄南', '黃南', 'Huang Nan'], '630000'],
	['632500', ['海南藏族', '海南藏族', 'Hainan Tibetans'], '630000'],
	['632600', ['果洛', '果洛', 'Guoluo'], '630000'],
	['632700', ['玉树', '玉樹', 'Yushu'], '630000'],
	['632800', ['海西', '海西', 'Haixi'], '630000'],
	['640100', ['银川', '銀川', 'Yinchuan'], '640000'],
	['640200', ['石嘴山', '石嘴山', 'Shizuishan'], '640000'],
	['640300', ['吴忠', '吳忠', 'Wu Zhong'], '640000'],
	['640400', ['固原', '固原', 'Guyuan'], '640000'],
	['640500', ['中卫', '中衛', 'Zhongwei'], '640000'],
	['650100', ['乌鲁木齐', '烏魯木齊', 'Urumqi'], '650000'],
	['650200', ['克拉玛依', '克拉瑪依', 'Karamay'], '650000'],
	['652100', ['吐鲁番', '吐魯番', 'Turpan'], '650000'],
	['652200', ['哈密', '哈密', 'Hami'], '650000'],
	['652300', ['昌吉', '昌吉', 'Changji'], '650000'],
	['652700', ['博尔塔拉', '博爾塔拉', 'Bortala'], '650000'],
	['652800', ['巴音郭楞', '巴音郭楞', 'Bayin Guoyu'], '650000'],
	['652900', ['阿克苏', '阿克蘇', 'Aksu'], '650000'],
	['653000', ['克孜勒苏柯尔克孜', '克孜勒蘇柯爾克孜', 'Kyzyl Sukirk'], '650000'],
	['653100', ['喀什', '喀什', 'Kashgar'], '650000'],
	['653200', ['和田', '和田', 'Wada'], '650000'],
	['654000', ['伊犁', '伊犁', 'Yili'], '650000'],
	['654200', ['塔城', '塔城', 'Tacheng'], '650000'],
	['654300', ['阿勒泰', '阿勒泰', 'Altay'], '650000'],
	['659001', ['石河子', '石河子', 'Shihezi'], '650000'],
	['659002', ['阿拉尔', '阿拉爾', 'Alar'], '650000'],
	['659003', ['图木舒克', '圖木舒克', 'Tumushuk'], '650000'],
	['659004', ['五家渠', '五家渠', 'Wujiaqu'], '650000']
];

function toTreeData(data) {
	return data.map(item => ({
		id: item[0],
		title: item[1][0],
		traditionalTitle: item[1][1],
		pinyinTitle: item[1][2],
		parentId: item[2]
	}));
}

export default function () {
	return [...toTreeData(PROVINCE), ...toTreeData(CITY)];
}